export default __webpack_public_path__ + "static/facebook-74bba8bb677c6a4651791fd708afaf42.svg";